import type {FC} from "react";

import type {WizardNavigation} from "../wizard.types";

/**
 * Navigation buttons (previous and next) component.
 */
export const WizardNavigationButtons: FC<{
  isValid: boolean,
  onProceed?: () => Promise<void> | void,
  navigation: WizardNavigation,
  testIdPrefix?: string,
  isFirstStep?: boolean,
  isLastStep?: boolean,
}> = ({testIdPrefix, isValid, onProceed, navigation, isFirstStep, isLastStep}) => {
  const prefix = testIdPrefix ?? 'nav'
  const prevButtonTestId = `${prefix}-prev`
  const nextButtonTestId = `${prefix}-next`

  const proceed = async () => {
    if (onProceed) {
      await onProceed()
    }
    navigation.nextStep()
  }

  return (
    <>
      {!isFirstStep &&
        <button data-testid={prevButtonTestId} className='btn btn-default me-3'
                onClick={navigation.previousStep}>Edellinen
        </button>
      }
      {!isLastStep &&
        <button data-testid={nextButtonTestId} className='btn btn-primary' disabled={!isValid}
                onClick={proceed}>Seuraava
        </button>
      }
    </>
  )
}
